<div class="ibox-content  mb-4">
  <div class="system-table">
    <div class="system-table-conteiner">
      <table >
        <thead>
          <tr>
            <th class="">Título</th>
            <th class="">Data</th>
            <th class="title">Arquivo</th>
            <th class=""></th>
          </tr>
        </thead>
        <tbody >
          <ng-container *ngFor="let item of data?.attachments">
            <tr >
              <td >{{item?.title}}</td>
              <td >{{item?.created_at | date: 'dd/MM/YYYY H:mm:s'}}</td>
              <td ><a class="file-name" (click)="download(item?.id, item?.name)">{{item?.name}}</a></td>
              <td >
                <div class="btn-icon">
                  
                  <button class="btn btn-font-icon ms-1" type="button" (click)="confirmExcluir(item?.id)"
                    alt="Deletar" title="Deletar">
                    delete
                  </button>
                  
                  <button class="btn btn-font-icon ms-1" type="button" (click)="openModal(item?.id)"
                    alt="Editar" title="Editar">
                    edit_square
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="button" (click)="openModal(0)">Novo Anexo</button>
    </div>
  </div>
</div>

<ng-template #modal>
  <app-anexos-edit [id]="id" [attach_id]="currentAttachId" (closeModal)="closeModal()" (excluir)="excluir(currentAttachId)"></app-anexos-edit>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>